import React, { useEffect } from 'react';
import './Blog.css'
import Aos from 'aos';
import "aos/dist/aos.css";


const Blog = () => {
     
  useEffect(() => {
     Aos.init({ duration:500});
 
   }, [])
 
    return ( 

    <>
<section id="blog" data-stellar-background-ratio="0.5">
          <div className="container">
               <div className="row">

                    <div className="col-md-12 col-sm-12">
                         <div className="section-title" data-aos="fade-up">
                              <h2>Our Blog</h2><br /><br />
                              <p>Some of the latest news from our blog</p>
                              <span className="line-bar">...</span><br />
                         </div>
                    </div>

                    <div className="col-md-6 col-sm-6 mav" data-aos="fade-up" data-aos-delay="50">
                         
                         <div className="media blog-thumb">
                              <div className="media-object media-left">
                                   <a href="/color-psychology-in-graphic-design"><img src={"assets/images/blog/blog-1.jpg"} className="img-responsive" alt=""/></a>
                              </div>
                              <div className="media-body blog-info">
                                   <small><i className="fa fa-clock-o"></i> May 20, 2023</small>
                                   <h3><a href="/color-psychology-in-graphic-design">Color Psychology in Graphic Design.</a></h3>
                                   <p sec-text>Colors have a profound impact on human psychology and can evoke specific emotions and moods.</p>
                                   <a href="/color-psychology-in-graphic-design" className="btn section-btn">Read article</a>
                              </div>
                         </div>
                    </div>

                    <div className="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="50">
                         
                         <div className="media blog-thumb">
                              <div className="media-object media-left">
                                   <a href="unleashing-the-power-of-data"><img src={"assets/images/blog/blog-2.jpg"} className="img-responsive" alt=""/></a>
                              </div>
                              <div className="media-body blog-info">
                                   <small><i className="fa fa-clock-o"></i> June 18, 2023</small>
                                   <h3><a href="unleashing-the-power-of-data">Unleashing the Power of Data.</a></h3>
                                   <p sec-text>Data analysis is a crucial skill in today's data-driven world.</p>
                                   <a href="unleashing-the-power-of-data" className="btn section-btn">Read more</a>
                              </div>
                         </div>
                    </div>

                    <div className="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                         
                         <div className="media blog-thumb">
                              <div className="media-object media-left">
                                   <a href="/essential-tools-every-web-developer-should-use"><img src={"assets/images/blog/blog-3.jpg"} className="img-responsive" alt=""/></a>
                              </div>
                              <div className="media-body blog-info">
                                   <small><i className="fa fa-clock-o"></i> July 14, 2023</small>
                                   <h3><a href="/essential-tools-every-web-developer-should-use">5 Essential Tools Every Web Developer Should Use.</a></h3>
                                   <p sec-text>In the world of web development, having the right set of tools</p>
                                   <a href="/essential-tools-every-web-developer-should-use" className="btn section-btn">Read article</a>
                              </div>
                         </div>
                    </div>

                    <div className="col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                         
                         <div className="media blog-thumb">
                              <div className="media-object media-left">
                                   <a href="/strategies-for-building-digital-campaign"><img src={"assets/images/blog/blog-4.jpg"} className="img-responsive" alt=""/></a>
                              </div>
                              <div className="media-body blog-info">
                                   <small><i className="fa fa-clock-o"></i> May 8, 2023</small>
                                   <h3><a href="/strategies-for-building-digital-campaign">5 Strategies for Building an Effective Digital Marketing Campaign.</a></h3>
                                   <p sec-text>In the era of digitalization, a well-executed digital.</p>
                                   <a href="/strategies-for-building-digital-campaign" className="btn section-btn">View Detail</a>
                              </div>
                         </div>
                    </div>
                    
               </div>
          </div>
     </section>

    </> 

    );
}
 
export default Blog;